import { isFunction, __DEV__, __TEST__ } from './assertions.es.js';

const callAllHandlers = (...fns) => (event) => {
  fns.some((fn) => {
    fn == null ? void 0 : fn(event);
    return event && event.defaultPrevented;
  });
};
const runIfFn = (value, ...args) => isFunction(value) ? value(...args) : value;
const warnings = /* @__PURE__ */ new Set();
const warn = (options) => {
  const { condition, message } = options;
  if (!condition || !__DEV__ || __TEST__) {
    return;
  }
  const key = message.toLowerCase().replace(/([^A-Za-z0-9[\]{}_:-])\s?/g, "");
  if (warnings.has(key)) {
    return;
  }
  warnings.add(key);
  console.warn("%c Maestro", "font-weight: bold; font-size: 1.05em;", "\n", message);
};
const error = (options) => {
  const { condition, message } = options;
  if (!condition || !__DEV__) {
    return;
  }
  const key = message.toLowerCase().replace(/([^A-Za-z0-9[\]{}_:-])\s?/g, "");
  if (warnings.has(key)) {
    return;
  }
  warnings.add(key);
  console.error("%c Maestro", "font-weight: bold; font-size: 1.05em;", "\n", message);
};
const noop = () => {
  return;
};

export { callAllHandlers, error, noop, runIfFn, warn };
//# sourceMappingURL=functions.es.js.map
